// token
import { TokenKey } from '@/settings'
export const setToken = (token: string) => localStorage.setItem(TokenKey, token)
export const getToken = () => localStorage.getItem(TokenKey)
export const removeToken = () => localStorage.removeItem(TokenKey)
